/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetEmployeeAttendanceById200ResponseRecordsInner
 */
export interface GetEmployeeAttendanceById200ResponseRecordsInner {
    /**
     * 
     * @type {string}
     * @memberof GetEmployeeAttendanceById200ResponseRecordsInner
     */
    name: string;
    /**
     * 
     * @type {Date}
     * @memberof GetEmployeeAttendanceById200ResponseRecordsInner
     */
    clockIn?: Date;
    /**
     * 
     * @type {Date}
     * @memberof GetEmployeeAttendanceById200ResponseRecordsInner
     */
    clockOut?: Date;
    /**
     * 
     * @type {string}
     * @memberof GetEmployeeAttendanceById200ResponseRecordsInner
     */
    reason: string;
    /**
     * 
     * @type {Date}
     * @memberof GetEmployeeAttendanceById200ResponseRecordsInner
     */
    createdAt: Date;
}

/**
 * Check if a given object implements the GetEmployeeAttendanceById200ResponseRecordsInner interface.
 */
export function instanceOfGetEmployeeAttendanceById200ResponseRecordsInner(value: object): value is GetEmployeeAttendanceById200ResponseRecordsInner {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('reason' in value) || value['reason'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    return true;
}

export function GetEmployeeAttendanceById200ResponseRecordsInnerFromJSON(json: any): GetEmployeeAttendanceById200ResponseRecordsInner {
    return GetEmployeeAttendanceById200ResponseRecordsInnerFromJSONTyped(json, false);
}

export function GetEmployeeAttendanceById200ResponseRecordsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetEmployeeAttendanceById200ResponseRecordsInner {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'clockIn': json['clockIn'] == null ? undefined : (new Date(json['clockIn'])),
        'clockOut': json['clockOut'] == null ? undefined : (new Date(json['clockOut'])),
        'reason': json['reason'],
        'createdAt': (new Date(json['createdAt'])),
    };
}

export function GetEmployeeAttendanceById200ResponseRecordsInnerToJSON(json: any): GetEmployeeAttendanceById200ResponseRecordsInner {
    return GetEmployeeAttendanceById200ResponseRecordsInnerToJSONTyped(json, false);
}

export function GetEmployeeAttendanceById200ResponseRecordsInnerToJSONTyped(value?: GetEmployeeAttendanceById200ResponseRecordsInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'clockIn': value['clockIn'] == null ? undefined : ((value['clockIn']).toISOString()),
        'clockOut': value['clockOut'] == null ? undefined : ((value['clockOut']).toISOString()),
        'reason': value['reason'],
        'createdAt': ((value['createdAt']).toISOString()),
    };
}

